export const userLogginData = [
    {
        id: 1,
        firstName: "Anuradha",
        lastName: "Malalasena",
        userName: "Anuradha Malalasena",
        email: "anuradha12345@gamil.com",	
        password: "123456",
    }
]